<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    <Header />

    <div class="bCardGlobalXXL mt-4" style="background-color: white !important; padding-top: 0px; padding-bottom: 0px;">
      <b-row>
        <b-col cols="3" class="p-4 d-flex flex-column" style="border: 1px solid #E0E0E0; border-radius: 20px;">
          <div class="mt-4 d-flex justify-content-center">
            <div class="circle d-flex justify-content-center align-items-center">
              <em v-if="objGuardar.sexo == 1" class="odontologo icono-odontologo"></em>
              <em v-if="objGuardar.sexo == 2" class="odontologa icono-odontologo"></em>
              <em v-if="objGuardar.sexo == 3 || objGuardar.sexo == null" class="diente_sexo" style="width: 3.3em;"></em>
            </div>
          </div>
          <p v-if="objGuardar.nombre != null && objGuardar.paterno != null && objGuardar.materno" class="mt-4" style="font-weight: 600;">{{objGuardar.nombre + ' ' + objGuardar.paterno + ' ' + objGuardar.materno}}</p>
          <p v-else class="mt-4" style="font-weight: 600;">Nuevo empleado</p>
          <div class="justify-content-center d-flex mt-3" >
           <!--  <div class="d-flex justify-content-center align-items-center pt-1" style="padding-bottom: 0px !important; background-color: #D2F6DC; width: 40%; border-radius: 15px; ">
              <p style="margin-bottom: 3%; font-size: .8em; color: #0f9936;">Ortodoncista</p>
            </div> -->
          </div>
          <div v-if="objGuardar.idEmpleado != null" class="d-flex justify-content-center mt-4">
              <b-button v-if="$localStorageService.can('BO_15_baja')" @click="actualizarColaborador(objGuardar.idEmpleado,objGuardar.nombre,false)" variant="outline-danger" class="d-flex justify-content-center boton-inv mt-1" style="padding-left: 0px;" v-b-tooltip.hover.right title="Dar de baja">
                <em class="eliminar icon-boton"></em>
              </b-button>
              <b-button @click="enviarCorreoFirma(objGuardar.idEmpleado)" variant="outline-info" class="d-flex justify-content-center boton-inv mt-1 ml-4" v-b-tooltip.hover.right title="Enviar correo">
                <em class="correo icon-boton"></em>
              </b-button>
          </div>

          <hr class="mt-4" style="width: 100%;">

          <div class="w-100 d-flex justify-content-center">
            <div class="mt-3" style="width: 80%; font-size: .8em;">
              <div class="d-flex justify-content-between">
                <p>Correo</p>
                <p v-if="objGuardar.correo != null">{{objGuardar.correo}}</p>
                <p v-else>Sin correo</p>
              </div>
              <div class="d-flex justify-content-between">
                <p>Teléfono</p>
                <p v-if="objGuardar.telCelular != null">{{objGuardar.telCelular}}</p>
                <p v-else>Sin teléfono</p>
              </div>
              <div class="text-left d-flex justify-content-between">
                <p>Fecha de nacimiento</p>
                <p v-if="objGuardar.fcNacimiento != null">{{objGuardar.fcNacimiento | formatoFechaCorta}}</p>
                <p v-else class="text-right">Sin fecha de nacimiento</p>
              </div>
              <div class="d-flex justify-content-between">
                <p>Sexo</p>
                <p v-if="objGuardar.sexo != null">{{sexoSeleccionado}}</p>
                <p v-else>Sin sexo</p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="pt-5">
          <p class="text-left mb-5 titulo-seccion" v-if="opSeleccionada == 1">Datos personales</p>
          <p class="text-left mb-5 titulo-seccion" v-if="opSeleccionada == 2">Datos de domicilio</p>
          <p class="text-left mb-5 titulo-seccion" v-if="opSeleccionada == 3">Datos del empleado</p>
          <p class="text-left mb-5 titulo-seccion" v-if="opSeleccionada == 4">Clínicas asignadas</p>
          <b-form @submit.stop.prevent="retirarClinica">
            <div v-if="opSeleccionada == 1">
              <div class="row">
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombre"
                    >Nombre(s)
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                        maxlength="20"
                        id="idNombre"
                        placeholder="Ingresa tu nombre(s)"
                        :state="validateState('nombre')"
                        v-model="$v.objGuardar.nombre.$model"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="paterno"
                    >Apellido paterno
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          maxlength="30"
                          id="paterno"
                          placeholder="Ingresa tu apellido paterno"
                          class="botonesformularios"
                          v-model="$v.objGuardar.paterno.$model"
                          :state="validateState('paterno')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Apellido materno
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          maxlength="30"
                          id="materno"
                          placeholder="Ingresa tu apellido materno"
                          class="botonesformularios"
                          :state="validateState('materno')"
                          v-model="$v.objGuardar.materno.$model"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Fecha de nacimiento
                      <validacion/>
                    </label>
                    <b-form-datepicker
                        locale="es-MX"
                        v-model="$v.objGuardar.fcNacimiento.$model"
                        labelNoDateSelected="Fecha de nacimiento"
                        :state="validateState('fcNacimiento')"
                        :max="new Date()"
                    ></b-form-datepicker>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label>Ocupación
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="text"
                          id="ocupacionComp"
                          :options="opcionesocupacionFiltro"
                          :reduce="(val) => val.value"
                          v-model="$v.objGuardar.ocupacion.$model"
                          placeholder="Selecciona una ocupación"
                          :filterable="false"
                          @search="filtroOpcionesocupacion"
                      ></v-select>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label>Sexo
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="text"
                          id="sexoComp"
                          :options="opcionessexoFiltro"
                          :reduce="(val) => val.value"
                          v-model="$v.objGuardar.sexo.$model"
                          placeholder="Selecciona un sexo"
                          :filterable="false"
                          @search="filtroOpcionessexo"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.sexo.$dirty && ($v.objGuardar.sexo.$invalid || $v.objGuardar.sexo.$error == 'true')"
                          texto="Selecciona un sexo"/>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label>Estado civil
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="text"
                          id="estCivilComp"
                          :options="opcionesestadocivilFiltro"
                          :reduce="(val) => val.value"
                          v-model="$v.objGuardar.estadoCivil.$model"
                          placeholder="Selecciona un estado civil"
                          :filterable="false"
                          @search="filtroOpcionesestadocivil"
                      ></v-select>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label>Tipo de seguridad electrónica
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="descripcion"
                          id="tipoSeguridad"
                          :options="opcionesTipoEmpleadoFiltro"
                          :reduce="(val) => val.idTipoEmpleado"
                          v-model="$v.objGuardar.tipoEmpleado.$model"
                          placeholder="Selecciona un tipo de seguridad"
                          :filterable="false"
                          @search="filtroOpcionesTipoEmpleado"
                      >
                      </v-select>
                      <validacion
                          v-if="$v.objGuardar.tipoEmpleado.$dirty && ($v.objGuardar.tipoEmpleado.$invalid || $v.objGuardar.tipoEmpleado.$error == 'true')"
                          texto="Selecciona un tipo de seguridad"/>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label>Cédula profesional
                    </label>
                    <b-input-group size="sm" class="mb-2"> 
                      <b-form-input
                          id="cedula"
                          placeholder="Ingresa la cedula profesional"
                          class="botonesformularios"
                          v-model="$v.objGuardar.cedula.$model"
                          :state="validateState('cedula')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label>Especialidades
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="especialidad"
                          id="especialidadComp"
                          :options="opcionesespecialidades"
                          :reduce="(val) => val.id"
                          v-model="$v.objGuardar.idEspecialidad.$model"
                          placeholder="Selecciona una especialidad"
                          multiple
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.idEspecialidad.$dirty && ($v.objGuardar.idEspecialidad.$invalid || $v.objGuardar.idEspecialidad.$error == 'true')"
                          texto="Selecciona una especialidad"/>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <div
                  class="formularios marginformularios d-flex justify-content-between"
               
              >
                <label class="bold marginlabel"
                       style="margin-top:5px"
                >Horario bloques</label>
                <b-form-checkbox
                    id="aplicaComisionBloque"
                    class="formularios marginformularios"
                    v-model="$v.objGuardar.aplicaComisionBloque.$model"
                    :state="validateState('aplicaComisionBloque')"
                    name="aplicaComisionBloque"
                ></b-form-checkbox>
              </div>
            <div
                class="formularios marginformularios d-flex justify-content-between"
                
            >
              <label class="bold marginlabel"
                     style="margin-top:5px"
              >Bono Extraordinario</label>
              <b-form-checkbox
                  id="aplicaBonoExtraordinario"
                  class="formularios marginformularios"
                  v-model="$v.objGuardar.aplicaBonoExtraordinario.$model"
                  :state="validateState('aplicaBonoExtraordinario')"
                  name="aplicaBonoExtraordinario"
              ></b-form-checkbox>
            </div>
  
                  <div
                      class="formularios marginformularios d-flex justify-content-between"
                      style="display:flex;align-items:center"
                  >
                    <label class="bold marginlabel"
                           style="margin-top:5px"
                    >Pago garantía</label>
                    <b-form-checkbox
                        id="pagoGarantia"
                        class="formularios marginformularios"
                        v-model="$v.objGuardar.pagoGarantia.$model"
                        :state="validateState('pagoGarantia')"
                        name="pagoGarantia"
                    ></b-form-checkbox>
                  </div>
                </div>
                <div class="col-4 text-left d-flex justify-content-between">
                  <div
                          class="formularios marginformularios d-flex justify-content-between"
                          
                      >
                        <label class="bold "
      
                        >Recibir notificaciones</label>
                        <b-form-checkbox
                            id="recibirCorreo"
                            class="formularios marginformularios"
                            v-model="$v.objGuardar.recibirCorreo.$model"
                            :state="validateState('recibirCorreo')"
                            name="recibirCorreo"
                            switch
                        ></b-form-checkbox>
                      </div>
                </div>
              </div>
            </div>

            <div v-if="opSeleccionada == 2">
              <div class="row">
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Calle
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          id="calle"
                          placeholder="Ingresa la calle"
                          class="botonesformularios"
                          :state="validateState('calle')"
                          v-model="$v.objGuardar.calle.$model"
                          aria-describedby="error-calle"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Código postal
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="name"
                          id="codigopostal"
                          class="botonesformularios"
                          :filterable="false"
                          :options="patients"
                          @search="consultarCP"
                          :reduce="(patient) => patient.id"
                          v-model="$v.objGuardar.codigoPostal.$model"
                          :state="validateState('codigoPostal')"
                          placeholder="Ingresa un código postal"
                      >
                        <template slot="no-options">Sin datos</template>
                      </v-select>
                      <validacion
                          v-if="$v.objGuardar.codigoPostal.$dirty && ($v.objGuardar.codigoPostal.$invalid || $v.objGuardar.codigoPostal.$error == 'true')"
                          texto="Escriba un código postal"/>
                    </b-input-group>
                  </b-form-group>
                </div> 
                <div class="col-4">
                  <b-form-group align="left">
                    <label>Colonia
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="text"
                          id="coloniaComp"
                          :options="opcionescolonia"
                          :reduce="(val) => val.value"
                          v-model="$v.objGuardar.colonia.$model"
                          placeholder="Selecciona una colonia"
                      ></v-select>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label>Delegación / Municipio
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="text"
                          id="munComp"
                          :options="opcionesdelegacionmunicipio"
                          :reduce="(val) => val.value"
                          v-model="$v.objGuardar.municipio.$model"
                          placeholder="Selecciona un municipio"
                      ></v-select>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label>Estado
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="text"
                          id="estadoComp"
                          :options="opcionesestado"
                          :reduce="(val) => val.value"
                          v-model="$v.objGuardar.estado.$model"
                          placeholder="Selecciona un estado"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.estado.$dirty && ($v.objGuardar.estado.$invalid || $v.objGuardar.estado.$error == 'true')"
                          texto="Selecciona un estado"/>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Número exterior
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          id="numero"
                          placeholder="Ingresa el número exterior"
                          class="botonesformularios"
                          type="number"
                          min="0"
                          :state="validateState('noExterior')"
                          v-model="$v.objGuardar.noExterior.$model"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Número interior
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          id="numerointerior"
                          placeholder="Ingresa el número de interior"
                          class="botonesformularios"
                          type="number"
                          min="0"
                          :state="validateState('noInterior')"
                          v-model="$v.objGuardar.noInterior.$model"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Referencia
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          id="referencias"
                          placeholder="Ingresa la referencia"
                          class="botonesformularios"
                          :state="validateState('referencia')"
                          v-model="$v.objGuardar.referencia.$model"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="email" class="bold marginlabel"
                    >Email
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          id="email"
                          placeholder="Ingresa el email"
                          class="botonesformularios"
                          v-model="$v.objGuardar.correo.$model"
                          type="email"
                          :state="validateState('correo')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Teléfono celular
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          id="numerocelular"
                          placeholder="Ingresa el celular"
                          v-mask="'(###) - ### - ####'"
                          v-model="$v.objGuardar.telCelular.$model"
                          :state="validateState('telCelular')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Teléfono de casa
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          id="numerocasa"
                          placeholder="Ingresa el numero de casa"
                          v-mask="'(###) - ### - ####'"
                          v-model="$v.objGuardar.telCasa.$model"
                          :state="validateState('telCasa')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group align="left">
                    <label for="nombreMenu"
                    >Teléfono de trabajo
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          id="otronumero"
                          placeholder="Ingresa el numero de trabajo"
                          v-mask="'(###) - ### - ####'"
                          v-model="$v.objGuardar.telTrabajo.$model"
                          :state="validateState('telTrabajo')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>
            </div>

            <div v-if="opSeleccionada == 3" class="row">
              <div class="col-4">
                <b-form-group align="left">
                  <label for="nombreMenu"
                  >Fecha de ingreso
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-datepicker
                        class="botonesformularios"
                        locale="es-MX"
                        labelNoDateSelected="Escoja una fecha"
                        v-model="$v.objGuardar.fechaAlta.$model"
                        :state="validateState('fechaAlta')"
                        :max="new Date()"
                    ></b-form-datepicker>
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-4">
                <b-form-group align="left">
                  <label>Nivel
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        id="nivel"
                        placeholder="Ingresa el nivel"
                        class="botonesformularios"
                        v-model="$v.objGuardar.nivel.$model"
                        :state="validateState('nivel')"
                        type="number"
                        min="0"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-4" v-if="objetoColaboradorEntrada !== undefined && objetoColaboradorEntrada !== null
              && objetoColaboradorEntrada.objetoColaborador !== undefined && objetoColaboradorEntrada.objetoColaborador !== null">
                <b-form-group style="margin-top: 6%" align="left">
                  <label>
                      Id de empleado ERP:
                  </label>
                  <label>
                    {{objetoColaboradorEntrada.objetoColaborador.numeroEmpleado}}
                  </label>
                </b-form-group>
              </div>
              <div class="col-4">
                <b-form-group align="left">
                  <label>Tipo de pago
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        style="width: 100%;"
                        label="text"
                        id="tipopagoComp"
                        :options="opcionesTipoPagoFiltro"
                        :reduce="(val) => val.value"
                        @input="validarTipoPago(true)"
                        v-model="$v.objGuardar.tipoPago.$model"
                        placeholder="Selecciona un tipo de pago"
                        :filterable="false"
                        @search="filtroOpcionesTipoPago"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.tipoPago.$dirty && ($v.objGuardar.tipoPago.$invalid || $v.objGuardar.tipoPago.$error == 'true')"
                        texto="Selecciona un tipo de pago"/>
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-4" v-if="objGuardar.tipoPago ===1">
                <b-form-group align="left">
                  <label>Tipo de regimen
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="nombreTipoRegimen"
                          id="segmentoComp"
                          :options="tiposRegimen"
                          :reduce="(val) => val.idTipoRegimen"
                          v-model="$v.objGuardar.idTipoRegimen.$model"
                          placeholder="Selecciona un segmento"
                          :filterable="true"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.idTipoRegimen.$dirty && ($v.objGuardar.idTipoRegimen.$invalid || $v.objGuardar.idTipoRegimen.$error == 'true')"
                          texto="Selecciona un tipo de regimen"/>
                    </b-input-group>
                </b-form-group>
              </div>
              <div class="col-4">
                <b-form-group align="left" v-if="objGuardar.tipoPago === 1">
                  <label>Segmento
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        style="width: 100%;"
                        label="descripcion"
                        id="segmentoComp"
                        :options="opcionessegmentoFiltro"
                        :reduce="(val) => val.idSegmento"
                        v-model="$v.objGuardar.idSegmento.$model"
                        placeholder="Selecciona un segmento"
                        :filterable="false"
                        @search="filtroOpcionessegmento"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.idSegmento.$dirty && ($v.objGuardar.idSegmento.$invalid || $v.objGuardar.idSegmento.$error == 'true')"
                        texto="Selecciona un segmento"/>
                  </b-input-group>
                </b-form-group>
                
                <b-form-group align="left" v-else>
                  <label>Tipo de regimen
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        style="width: 100%;"
                        label="nombreTipoRegimen"
                        id="segmentoComp"
                        :options="tiposRegimen"
                        :reduce="(val) => val.idTipoRegimen"
                        v-model="$v.objGuardar.idTipoRegimen.$model"
                        placeholder="Selecciona un segmento"
                        :filterable="true"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.idTipoRegimen.$dirty && ($v.objGuardar.idTipoRegimen.$invalid || $v.objGuardar.idTipoRegimen.$error == 'true')"
                        texto="Selecciona un tipo de regimen"/>
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-4">
                <b-form-group align="left">
                  <label>Esquema de contratación
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-select
                        v-model="$v.objGuardar.esquema.$model"
                        :options="opcionesesquema"
                        class="botonesformularios"
                        :disabled="bloquearEsquema"
                        :state="validateState('esquema')"
                    ></b-form-select>
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-4">
                <b-form-group align="left">
                  <label>Jefe directo
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        :clearable="true"
                        :filterable="false"
                        :options="opcionesJefeDirecto"
                        label="nombre"
                        @search="consultarJefeDirecto"
                        v-model="$v.objGuardar.jefeDirecto.$model"
                        :state="validateState('codigoPostal')"
                        placeholder="Selecciona el jefe directo"
                        style="width: 100%"
                    >
                      <span slot="no-options">No hay jefes disponibles</span>
                    </v-select>
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-4">
                <b-form-group align="left">
                  <label>Firma empleado</label>
                </b-form-group>
              <div v-if="objGuardar.firma == null ">
                <strong> Aún no hay firma </strong>
              </div>
              <div v-else class="container" >
                  <img width="100%" class="contFirmaEmpleado"
                       :src="'data:image/png;base64,'+ objGuardar.firma"
                       alt="firma"
                  />
              </div>
              </div>
            </div>

            <div v-if="opSeleccionada == 4">
              <b-form-group align="left">
                <label>Clínicas</label>
                <validacion/>
                <b-input-group size="sm" class="mb-2">
                  <v-select :clearable="false" :options="opcionesclinicas"
                            v-model="$v.objGuardar.idClinica.$model"
                            :reduce="(variable) => variable.idClinica" label="strNombre"
                            placeholder="Selecciona una ó varias clínicas"
                            style="width: 100%" multiple
                  >

                    <span slot="no-options">No hay clínicas disponibles</span>
                  </v-select>
                  <validacion
                      v-if="$v.objGuardar.idClinica.$dirty && ($v.objGuardar.idClinica.$invalid || $v.objGuardar.idClinica.$error)"
                      texto="Selecciona una clínica"/>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-flex justify-content-center mb-4" style="margin-top: 6%;">
              <b-button ref="submitGuardar" variant="info" type="submit">Guardar</b-button>
              <b-button @click="cancelarProceso()" class="ml-5" variant="outline-secondary">Cancelar</b-button>
            </div>
            
          </b-form>
        </b-col>
        <b-col class="col-auto" style="border-left: 1px solid #E0E0E0; padding-left: 0px;">
            <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100%;">
              <div class="d-flex flex-column justify-content-between" style="height: 45vh;">
                <div @click="opSeleccionada = 1" class="div-menu" :class="{ 'div-menu-seleccionado': opSeleccionada === 1}">
                  <em class="datos_generales icono-menu" :class="{ 'icono-menu-seleccionado': opSeleccionada === 1 }"></em>
                </div>
                <div @click="opSeleccionada = 2" class="div-menu" :class="{ 'div-menu-seleccionado': opSeleccionada === 2}">
                  <em class="datos_domicilio icono-menu" :class="{ 'icono-menu-seleccionado': opSeleccionada === 2 }"></em>
                </div>
                <div @click="opSeleccionada = 3" class="div-menu" :class="{ 'div-menu-seleccionado': opSeleccionada === 3}">
                  <em class="datos_empleado icono-menu" :class="{ 'icono-menu-seleccionado': opSeleccionada === 3 }"></em>
                </div>
                <div @click="opSeleccionada = 4" class="div-menu" :class="{ 'div-menu-seleccionado': opSeleccionada === 4}">
                  <em class="datos_clinicas icono-menu" :class="{ 'icono-menu-seleccionado': opSeleccionada === 4 }"></em>
                </div>
                <!-- <div @click="opSeleccionada = 5" class="div-menu" :class="{ 'div-menu-seleccionado': opSeleccionada === 5}">
                  <em class="datos_sku icono-menu" :class="{ 'icono-menu-seleccionado': opSeleccionada === 5 }"></em>
                </div> -->
              </div>
            </div>
        </b-col>
      </b-row>
    </div>
    
  </div>
</template>

<script>
import "vue-datetime/dist/vue-datetime.css";
import {validationMixin} from "vuelidate";
import {required, minLength, maxLength} from "vuelidate/lib/validators";
import Header from "../../components/Header.vue";

export default {
  nombreMenu: "CrearEditar",
  components: {
    Header
  },
  mixins: [validationMixin],
  data: function () {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      opSeleccionada: 1,
      objetoColaboradorEntrada: null,
      tiposRegimen: [],
      canalesOrigen: [],
      loading: false,
      controladorTiempo: null,
      optionsclinicas: [],
      patients: [],
      opcionessexo: [],
      opcionessexoFiltro: [],
      opcionesJefeDirecto: [],
      opcionesTipoPago: [],
      opcionesTipoPagoFiltro: [],
      opcionesclinicas: [],
      opcionesesquema: [],
      opcionesestadocivil: [],
      opcionesestadocivilFiltro: [],
      opcionesocupacion: [],
      opcionesocupacionFiltro: [],
      opcionesTipoEmpleado: [],
      opcionesTipoEmpleadoFiltro: [],
      opcionescolonia: [],
      opcionesestado: [],
      opcionesdelegacionmunicipio: [],
      opcionessegmento: [],
      opcionessegmentoFiltro: [],
      opcionesespecialidades: [],

      objGuardar: {
        nombre: null,
        idPersona: null,
        paterno: null,
        materno: null,
        fcNacimiento: null,
        sexo: null,
        estadoCivil: null,
        ocupacion: null,
        tipoEmpleado: null,
        calle: null,
        noExterior: null,
        noInterior: null,
        referencia: null,
        codigoPostal: null,
        colonia: null,
        estado: null,
        municipio: null,
        correo: null,
        telCelular: null,
        telCasa: null,
        telTrabajo: null,
        cedula: null,
        fechaAlta: null,
        tipoPago: null,
        tiempoCompleto: null,
        aplicaComisionBloque: null,
        recibirCorreo: false,
        aplicaBonoExtraordinario: null,
        pagoGarantia: null,
        nivel: 1,
        esquema: null,
        jefeDirecto: null,
        asesorconfianza: null,
        idClinica: [],
        idEspecialidad: [],
        idSegmento: null,
        numeroEmpleado: null,
        firma: null,
        idTipoRegimen: null,
        idCanalOrigen: 1
      },

      bloquearEsquema: true,

      existeFirmaEmpleado: false,
      idEmpleado: null,
      mostrarComponenteFirma: false,
      editar: false,
      cancelar: false,
      comisionesClinica: [],
      fields: [
          { key: "clinica", label: "Clínica" },
          { key: "comision", label: "Comisión base especialista" },
        ],
    };
  },
  validations() {
    const validaciones = {
      objGuardar: {
        nombre: {required, maxLength: maxLength(70)},
        idPersona: {},
        paterno: {required, maxLength: maxLength(70)},
        materno: {required, maxLength: maxLength(70)},
        fcNacimiento: {required},
        sexo: {required},
        estadoCivil: {},
        ocupacion: {},
        tipoEmpleado: {required},
        calle: {maxLength: maxLength(100)},
        noExterior: {maxLength: maxLength(50)},
        noInterior: {maxLength: maxLength(50)},
        referencia: {maxLength: maxLength(255)},
        codigoPostal: {required},
        colonia: {},
        estado: {required},
        municipio: {},
        correo: {required, maxLength: maxLength(150)},
        telCelular: {required, minLength: minLength(18), maxLength: maxLength(18)},
        telCasa: {minLength: minLength(18), maxLength: maxLength(18)},
        telTrabajo: {minLength: minLength(18), maxLength: maxLength(18)},
        cedula: {maxLength: maxLength(12)},
        fechaAlta: {},
        tipoPago: {required},
        tiempoCompleto: {},
        aplicaComisionBloque:{},
        recibirCorreo:{},
        aplicaBonoExtraordinario:{},
        pagoGarantia:{},
        nivel: {minLength: minLength(1), maxLength: maxLength(2)},
        esquema: {required},
        jefeDirecto: {},
        asesorconfianza: {},
        idClinica: {required},
        idEspecialidad: {required},
        idTipoRegimen: {required},
     
      }
    };

    if (this.objGuardar.tipoPago !== undefined && this.objGuardar.tipoPago !== null && this.objGuardar.tipoPago === 1) {
      validaciones.objGuardar.idSegmento = {required};
    } else {
      validaciones.objGuardar.idSegmento = {};
    }

    return validaciones
  },
  methods: {
    cancelarProceso(){
      this.$swal.fire({
        title: "Cancelar proceso",
        text: "¿Estás seguro de salir? No se guardarán los cambios",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, salir",
        cancelButtonText: "No, regresar",
        showLoaderOnConfirm: true,

        preConfirm: () => {
          this.$router.push({name: "colaboradores", params: {}});
        }
      })
    },

    enviarCorreoFirma(idEmpleado) {
      this.loading = true;
      for (var al = ""; al.length < 20; )
        al += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz"[
          (Math.random() * 60) | 0
        ];
      this.token = al;
      this.$http
        .get(
          this.$api +
            "correos/firmaExternaColaborador/" +
            idEmpleado +
            "/" +
            this.token
        )
        .then((r) => {
          if (r.status == 200) {
            this.$swal({
              icon: "success",
              title: "Correo enviado al colaborador",
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            this.$swal({
              icon: "warning",
              title: "Ups! algo salió mal",
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    actualizarColaborador(idEmpleado, nombre, registroActivo) {
      this.loading = true;
      this.datosContinuarProcesoInactivarColaborador = [];
      var textoAccion = "";
      if (!registroActivo) {
        textoAccion = "¿Desea dar de baja al colaborador?";
      } else {
        textoAccion = "¿Desea dar de alta al colaborador?";
      }
      this.$swal.fire({
        title: textoAccion,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,

        preConfirm: () => {
          this.loaderGuardar = true;
          const params = {
            idEmpleado: idEmpleado,
            activar: registroActivo,
          };
          let peticion =
            this.$api + "colaboradores/activarDesactivarColaborador";
          this.$http
            .post(peticion, params)
            .then(async() => {
              await this.$swal.fire({
                position: "center",
                icon: "success",
                title: "El colaborador se dio de baja exitosamente",
                showConfirmButton: false,
                timer: 2000,
              });
              this.loading = false;
              this.$router.push({name: "colaboradores", params: {}});

            })
            .catch(() => {
              this.$swal.fire({
                position: "center",
                icon: "error",
                title: "Hubo un error al actualizar al colaborador",
                showConfirmButton: false,
                timer: 2000,
              });
            })
            .finally(() => {
              this.loaderGuardar = false;
            });
        },
      });
    },
    obtenerComisionPorClinica(idClinica){
      this.$http
            .post(
                this.$api +
                "catalogos/obtener/comisionEspecialistaClinica",
                idClinica
            )
            .then((response) => {
              response.data.data.forEach(element => {
                let comision = {
                  clinica: element.strNombre,
                  comision: element.comisionBaseEspecialistas
                }

                this.comisionesClinica.push(comision)
              });
            }).catch((error) => {
              console.error(error)
            })
    },
    filtroOpcionessegmento(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionessegmentoFiltro= this.opcionessegmento.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },


    filtroOpcionesTipoPago(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesTipoPagoFiltro= this.opcionesTipoPago.filter(em => {
        return em.text.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesocupacion(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesocupacionFiltro = this.opcionesocupacion.filter(em => {
        return em.text.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesTipoEmpleado(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesTipoEmpleadoFiltro = this.opcionesTipoEmpleado.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesestadocivil(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesestadocivilFiltro = this.opcionesestadocivil.filter(em => {
        return em.text.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionessexo(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionessexoFiltro = this.opcionessexo.filter(em => {
        return em.text.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },
    consultarCP(searchTerm, loading) {
      loading(true);
      const _this = this;
      if (searchTerm === "") {
        loading(false);
        return false;
      }
      if (searchTerm != undefined) {
        var inputTxt = searchTerm;
        const params = {
          codigoPostal: inputTxt
        }
        this.$http
            .post(this.$api + "localidad/postales", params)
            .then((response) => {
              if (response.status === 200) {
                if (Array.isArray(response.data.data) == true) {
                  const uniqueAddresses = Array.from(
                      new Set(response.data.data.map((a) => a.idLocalidad))
                  ).map((idLocalidad) => {
                    return response.data.data.find(
                        (a) => a.idLocalidad === idLocalidad
                    );
                  });
                  _this.opcionescolonia = [];
                  _this.opcionesestado = [];
                  _this.opcionesdelegacionmunicipio = [];
                  this.patients = [];
                  uniqueAddresses.forEach((element) => {
                    this.patients.push({
                      id: element.codigoPostal,
                      name: element.codigoPostal,
                    });
                  });
                  let tempcodigopostal = this.patients.filter(
                      (v, i, a) =>
                          a.findIndex(
                              (t) => t.label === v.label && t.value === v.value
                          ) === i
                  );
                  this.patients = tempcodigopostal;

                  if (this.patients.length == 1) {
                    this.objGuardar.codigoPostal = this.patients[0].id;
                  } else {
                    this.objGuardar.codigoPostal = null;
                  }

                  var i = 0;
                  response.data.data.forEach(function (item) {
                    i++;
                    let itemcolonia = {
                      value: i,
                      text: item.nombreLocalidad,
                    };
                    _this.opcionescolonia.push(itemcolonia);
                    let itemdelegacionmunicipio = {
                      value: 1,
                      text: item.nombreMunicipio,
                    };
                    let itemestado = {
                      value: 1,
                      text: item.nombreEstado,
                    };
                    _this.opcionesestado.push(itemestado);
                    _this.opcionesdelegacionmunicipio.push(
                        itemdelegacionmunicipio
                    );
                  });

                  let tempdelegacionmunicipio = _this.opcionesdelegacionmunicipio.filter(
                      (v, i, a) => a.findIndex((t) => t.id === v.id) === i
                  );
                  let tempestado = _this.opcionesestado.filter(
                      (v, i, a) => a.findIndex((t) => t.id === v.id) === i
                  );

                  _this.opcionesdelegacionmunicipio = tempdelegacionmunicipio;
                  _this.opcionesestado = tempestado;


                  if (_this.opcionesestado.length === 1) {
                    _this.objGuardar.estado = _this.opcionesestado[0].value;
                  }
                  if (_this.opcionesdelegacionmunicipio.length === 1) {
                    _this.objGuardar.municipio = _this.opcionesdelegacionmunicipio[0].value;
                  }
                  if (_this.opcionescolonia.length === 1) {
                    _this.objGuardar.colonia = _this.opcionescolonia[0].value;
                  }
                }
              }
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => loading(false));
      }
    },
    consultarJefeDirecto(searchTerm, loading) {
      this.opcionesJefeDirecto = [];
      loading(true);
      if (searchTerm === "") {
        loading(false);
        return false;
      }
      if (searchTerm != undefined && searchTerm.length > 3) {

        clearTimeout(this.controladorTiempo);
        this.controladorTiempo = setTimeout(() => {
          const params = {
            pagina: 1,
            filtro: searchTerm
          }
          this.$http
              .post(this.$api + "colaboradores/obtenerDoctoresActivos", params)
              .then((response) => {
                this.opcionesJefeDirecto = response.data.data.colaboradores;

                if (this.opcionesJefeDirecto !== undefined && this.opcionesJefeDirecto !== null) {
                  this.objGuardar.jefeDirecto = this.opcionesJefeDirecto[0];
                }
              })
              .catch((error) => {
                console.error(error);
              })
              .finally(() => loading(false));

          clearTimeout(this.controladorTiempo);
        }, 1000);
      }
    },
    cargarCatalagos() {
      this.opcionesTipoPago = this.objetoColaboradorEntrada.catalogos.tipoPago;
      this.opcionesTipoPagoFiltro = this.opcionesTipoPago;
      this.opcionessexo = this.objetoColaboradorEntrada.catalogos.sexo;
      this.opcionessexoFiltro =  this.opcionessexo;
      this.opcionesclinicas = this.objetoColaboradorEntrada.catalogos.clinicas;
      //this.opcionesesquema = this.objetoColaboradorEntrada.catalogos.esquema;
      this.opcionesestadocivil = this.objetoColaboradorEntrada.catalogos.estadocivil;
      this.opcionesestadocivilFiltro = this.opcionesestadocivil;
      this.opcionesocupacion = this.objetoColaboradorEntrada.catalogos.ocupacion;
      this.opcionesocupacionFiltro = this.opcionesocupacion;
      this.opcionesTipoEmpleado = this.objetoColaboradorEntrada.catalogos.tipoEmpleado;
      this.opcionesTipoEmpleadoFiltro = this.opcionesTipoEmpleado;
      this.opcionessegmento = this.objetoColaboradorEntrada.catalogos.segmentos;
      this.opcionessegmentoFiltro = this.opcionessegmento;
      this.opcionesespecialidades = this.objetoColaboradorEntrada.catalogos.especialidades;
    },
    crearObjetoColaborador() {
      if (this.objetoColaboradorEntrada.objetoColaborador === null) {
        this.objGuardar.idCompania = 1
        this.objGuardar.crmId = "";
        //this.objGuardar.correoDominio = "@dentalia.com"
        this.obtenerMatrizPuestoEsquema(true);
      } else {
        this.loading = true;
        this.objGuardar = {};

        this.$http
            .get(
                this.$api +
                "colaboradores/obtenerInformacionColaboradorPorIdPersona?idPersona=" +
                this.objetoColaboradorEntrada.objetoColaborador.idPersona
            )
            .then((response) => {
              this.objGuardar = response.data.data;
              //const indice = this.objGuardar.correo.indexOf("@");
              //if (indice > 0) {
                //this.objGuardar.correoDominio = this.objGuardar.correo.substring(indice, this.objGuardar.correo.length);
                //this.objGuardar.correo = this.objGuardar.correo.substring(0, indice);
              //}
              //this.objGuardar.correo.replace("@", "");

              const loadingCP = function () {
              }

              this.consultarCP(this.objGuardar.codigoPostal, loadingCP);

              this.objGuardar.jefeDirecto = {};
              this.consultarJefeDirecto(this.objGuardar.jefeDirectoNombre, loadingCP);

              if (this.objGuardar.firma === null ){
                this.mostrarComponenteFirma= true
                this.cancelar = false
              }else {
                this.mostrarComponenteFirma = false
                this.cancelar = true
              }
            })
            .catch((error) => {
              console.error(error);
            }).finally(() => {
          this.obtenerMatrizPuestoEsquema(false);
          this.loading = false;
        });
      }
    },
    retirarClinica(){

      if (this.objetoColaboradorEntrada.objetoColaborador === null || this.objetoColaboradorEntrada.objetoColaborador.idPersona === undefined || this.objetoColaboradorEntrada.objetoColaborador.idPersona == null){
        this.guardar();
      } else {




        this.loading = true;
        this.$http
            .put(this.$api + "colaboradores/retirarClinicaAColaborador?idPersona="
                + this.objetoColaboradorEntrada.objetoColaborador.idPersona, this.objGuardar.idClinica)
            .then((response) => {



              if (response.data.data.continuarProceso == true) {



                this.guardar();
              }else {
                this.$swal.fire({
                  title: response.data.message,
                  icon: "warning",
                  confirmButtonText: "Aceptar",
                  showLoaderOnConfirm: true,
                  preConfirm: () => {
                  },
                });
              }
              this.loading = false;



            })
            .catch((error) => {
              console.error(error)
              this.loading = false;



            })
            .finally(() => {
              this.loading = false;
            });
      }
    },


    guardar() {
      this.$v.objGuardar.$touch();
      if (this.$v.objGuardar.$anyError) {
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Por favor llene los datos obligatorios.",
        });

        return;
      }

      const objetoGuardar = JSON.parse(JSON.stringify(this.objGuardar));
      objetoGuardar.jefeDirecto = this.objGuardar.jefeDirecto != null && this.objGuardar.jefeDirecto.idEmpleado != null ? this.objGuardar.jefeDirecto.idEmpleado : null;

        this.crearColaborador(objetoGuardar);

    },

    crearColaborador(valores) {
      this.loader = true;
      const config = {
        header: {
          "Content-Type": "image/png",
        },
      };

      const objGuardar = JSON.parse(JSON.stringify(valores));

      objGuardar.fechaAlta =
        objGuardar.fechaAlta != null
          ? this.$moment(objGuardar.fechaAlta)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm[:00Z]")
          : null;
      objGuardar.fcNacimiento = this.$moment(objGuardar.fcNacimiento)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm[:00Z]");

      const found = objGuardar.idClinica.filter(
        (element) => element == undefined
      );

      if (found.length > 0) {
        found.forEach((dato) => {
          let index = objGuardar.idClinica.indexOf(dato);
          objGuardar.idClinica.splice(index, 1);
        });
      }
      objGuardar.nombre = objGuardar.nombre.trim();
      objGuardar.paterno = objGuardar.paterno.trim();
      objGuardar.materno = objGuardar.materno.trim();
      objGuardar.idCanalOrigen = 1;
      this.$http
        .post(this.$api + "colaboradores/crearColaborador", objGuardar, config)
        .then(async(response) => {
          await this.$swal.fire({
            position: "center",
            icon: "success",
            title:
              "Se guardó al colaborador con el usuario: " + response.data.data,
            showConfirmButton: false,
            timer: 2000,
          });
          

          this.filter =
            objGuardar.nombre +
            " " +
            objGuardar.paterno +
            " " +
            objGuardar.materno;

        
        })
        .catch((error) => {

          this.$swal.fire({
            position: "center",
            icon: "error",
            title: error.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
          
        })
        .finally(() => {
          this.loaderAcciones = false;
          this.loader = false;
          
        });
    },
    esSoloCorreo($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if (keyCode == 64) {
        $event.preventDefault();
      }
    },
    verificarCorreo(e) {
      if (e !== undefined && e !== null) {
        this.objGuardar.correo = e.replace("@", "");
      }
    },
    obtenerMatrizPuestoEsquema(reinicarEsquema) {
      this.loadingMatrizPE = true;
      this.matrizPE = [];
      this.$http
          .get(
              this.$api +
              "catalogos/obtenerMatrizTipoPagoPorEsquema"
          )
          .then((response) => {
            this.matrizPE = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() => {
            this.validarTipoPago(reinicarEsquema);
        this.loading = false;
      });
    },

    validarTipoPago(reinicarEsquema) {
      this.bloquearEsquema = true;

      if(reinicarEsquema) {
        this.objGuardar.esquema = [];
      }

      if (this.matrizPE !== undefined) {
        const matrizTipoPago = this.matrizPE.filter(it => it.idTipoPago === this.objGuardar.tipoPago);

        if (matrizTipoPago !== undefined && matrizTipoPago.length > 0) {
          this.opcionesesquema = matrizTipoPago.map(it => {
            return {"value": it.idEsquema, "text": it.nombreEsquema}
          });

          if (this.opcionesesquema.length > 1) {
            this.bloquearEsquema = false;
          } else {
            this.objGuardar.esquema = matrizTipoPago.shift().idEsquema;
          }
        }
      }
    },
  },
  computed:{
    sexoSeleccionado(){
      let opcionSeleccionada = this.opcionessexo.find(opcion => opcion.id === this.objGuardar.sexo);
    return opcionSeleccionada ? opcionSeleccionada.nombre : '';
    }
  },
  created () {
    this.debug = this.$localStorageService.getDebug();
    this.objetoColaboradorEntrada = JSON.parse(localStorage.getItem("infoColaborador"))
    this.tiposRegimen = JSON.parse(localStorage.getItem("tiposRegimen"))
    this.canalesOrigen = JSON.parse(localStorage.getItem("canalesOrigen"))
    /* localStorage.removeItem('infoColaborador');
    localStorage.removeItem('tiposRegimen');
    localStorage.removeItem('canalesOrigen'); */
    this.cargarCatalagos();
    this.$nextTick(() => {
      this.$v.$reset()
    });
    this.crearObjetoColaborador();
  }, 
  watch: {
    "objGuardar.idClinica": function (val) {
      this.obtenerComisionPorClinica(val)
    }
  }
}
;
</script>
<style >
.titulo-seccion{
  font-weight: 600;
  color: #0069A9;
}

  .circle {
  width: 7em;
  height: 7em;
  border-radius: 50%;
  background-color: #EDF5FE; /* Cambia este color según tus necesidades */
}

.icono-odontologo {
  width: 7em;
  height: 7em;
}

.icon-boton {
  margin-left: 0px;
  height: 15px;
  display: block;
}

.boton-inv, .boton-inv:hover {
  margin-top: -10px;
  border-radius: 10rem !important;
  width: 29px;
  padding-left: 0px;
  color:  var(--color-icono);
  background-color: white;
  border-color: #F19E14;
  filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));
  padding: 5px;
}

.contFirmaEmpleado {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.icono-menu{
  width: 30px;
}

.div-menu{
  padding-left: 10%;
}

.div-menu-seleccionado{
  border-left: 5px solid #53BACA;
}

.icono-menu-seleccionado{
  filter: brightness(0) saturate(100%) invert(71%) sepia(27%) saturate(725%) hue-rotate(140deg) brightness(87%) contrast(94%);
}



</style>
